window.addEventListener('DOMContentLoaded', function (e) {
    const filterList = document.querySelector('.woof_sid_auto_shortcode');

    if (filterList) {
        const newEl = document.createElement('div');

        newEl.innerHTML = '<p>Filter</p>';

        newEl.classList.add('toggle');

        filterList.appendChild(newEl);

        document.querySelector(".woof_sid_auto_shortcode .toggle").onclick = function () {
            document.querySelector(".woof_sid_auto_shortcode").classList.toggle("filter_open");
        };
    }

    var buffer;
    var getBuffer = setInterval(() => {
        buffer = document.getElementById('woof_html_buffer');
        if (buffer) {
            clearInterval(getBuffer);
        }
    }, 50)

    // Child and parent filters logic
    const checkList = document.querySelector('.woof_list_checkbox');
    const checkboxes = checkList.querySelectorAll('.woof_checkbox_term');
    var loadedCats = new URLSearchParams(window.location.search).get('product_cat');

    var checked = loadedCats ? loadedCats.split(',') : [];

    checkboxes?.forEach(checkbox => {
        checkbox.addEventListener('click', async (e) => {
            e.preventDefault();
            buffer?.setAttribute('style', 'display: block; opacity: 0.9');
            buffer?.classList.add('manual');

            const thisName = checkbox.getAttribute('name');
            const index = checked.indexOf(thisName);

            // If checked, uncheck it
            if (index >= 0) {
                checked?.splice(index, 1);
                await traverseParents(checkbox.parentNode.parentNode.closest('.woof_childs_list_li'));
                await traverseChildren(checkbox.parentNode.querySelector('.woof_childs_list'), true);
            }
            // If unchecked, check it
            else {
                checked?.push(thisName)
                await traverseParents(checkbox.parentNode.parentNode.closest('.woof_childs_list_li'));
                await traverseChildren(checkbox.parentNode.querySelector('.woof_childs_list'), false);
            }

            // Now that the correct boxes are checked, load the new results
            loadPage();
        })
    })

    async function traverseParents(el) {
        if (el) {
            // Check if all children are checked, then check this box. Otherwise, uncheck it.
            let checkbox = el.querySelector('.woof_checkbox_term');

            // Get list of all children below and see if they're in the checked list
            let temp = el.querySelector('.woof_childs_list');
            let children = temp.querySelectorAll('input.woof_checkbox_term');
            let uncheckedChild = false;

            for (let i = 0 ; i < children.length ; i++) {
                if (checked?.indexOf(children[i].getAttribute('name')) < 0) {
                    uncheckedChild = true;
                    break;
                }
            }

            let index = checked?.indexOf(checkbox.getAttribute('name'));

            if (uncheckedChild) {
                // At least one child is unchecked, so uncheck the parent
                if (index >= 0) {
                    checked?.splice(index, 1);
                }
            } else {
                // No unchecked children, so check the parent
                // Checking if it's already in the list to avoid duplicates
                if (index < 0) {
                    checked?.push(checkbox.getAttribute('name'));
                }
            }

            traverseParents(el.parentNode.parentNode.closest('.woof_childs_list_li'));
        }
    }

    async function traverseChildren(el, uncheck) {
        if (el) {
            if (uncheck) {
                el.querySelectorAll('.woof_checkbox_term')?.forEach(child => {
                    let index = checked?.indexOf(child.getAttribute('name'));

                    if (index >= 0) {
                        checked?.splice(index, 1);
                    }
                })
            } else {
                el.querySelectorAll('.woof_checkbox_term')?.forEach(child => {
                    checked?.push(child.getAttribute('name'))
                })
            }
        }
    }

    function loadPage() {
        checked = [...new Set(checked)]; // This should catch edge cases where duplicate terms are included in the URL or there's a mistake in the logic below that results in duplicate items
        const newQuery = checked?.join(',');
        if (newQuery == '') {
            window.location = `${window.location.origin}${window.location.pathname}`;
        } else {
            window.location = `${window.location.origin}${window.location.pathname}?swoof=1&product_cat=${newQuery}`;
        }
    }
})